import { Divider, Stack, Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { useDynamicFormContext } from './dynamic_form.context';
import { useFormWorkerState } from './form_manager/use_form_worker';

export function DynamicFormDescription(): JSX.Element | null {
	const context = useDynamicFormContext();
	const { meta } = useFormWorkerState(context.formWorker);

	if (meta == null) {
		return null;
	}

	return (
		<>
			<Stack gap={tokens.spacing.x1}>
				<Text variant='headingSmall'>{meta.header}</Text>
				<Text variant='bodyRegular'>{meta.description}</Text>
			</Stack>

			<Divider />
		</>
	);
}
